import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Stack, Dialog, Button, Typography, DialogContent, DialogActions } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import * as Yup from 'yup';

import { TopupTxType } from 'src/type/topup-deposit';
import useCurrentDateTime from 'src/hooks/use-current-date-time';

type ApproveDialogProps = {
  open: boolean;
  onClose: () => void;
  tx: TopupTxType;
  handleReload: () => void;
};

export default function TopupRejectDialog({ open, onClose, tx, handleReload }: ApproveDialogProps) {
  const currentDateTime = useCurrentDateTime();

  const Schema = Yup.object().shape({
    note: Yup.string(),
  });

  const defaultValues = {
    note: '',
  };

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const beforeClose = () => {
    reset(defaultValues);
    onClose();
  };

  const onSubmit = handleSubmit(async (values) => {
    try {
      await axios.post(endpoints.transactions.topupDeposit.reject(tx.id), {
        note: values.note,
        currentDateTime,
      });

      handleReload();
      beforeClose();
      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
    } catch (error) {
      toastError(error);
    }
  });

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <Stack direction="row" alignItems="center" sx={{ p: 3 }}>
          <Typography variant="h6">ปฏิเสธรายการเติมวงเงินหลักประกัน</Typography>
        </Stack>

        <DialogContent>
          <RHFTextField
            multiline
            rows={3}
            name="note"
            placeholder="หมายเหตุ"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={beforeClose} disabled={isSubmitting}>
            ยกเลิก
          </Button>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
            ดำเนินการต่อ
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
